module.exports = __webpack_public_path__ + "img/ae.517cd85.svg";